export default {
  // Page title
  'page.title': 'Timer',

  // Popular timers
  'popular.title': 'Beliebte Timer',
  'popular.10s': '10 Sekunden Timer',
  'popular.20s': '20 Sekunden Timer',
  'popular.30s': '30 Sekunden Timer',
  'popular.40s': '40 Sekunden Timer',
  'popular.50s': '50 Sekunden Timer',
  'popular.90s': '1,5 Minuten Timer',
  'popular.2minute': '2 Minuten Timer',
  'popular.3minute': '3 Minuten Timer',
  'popular.5minute': '5 Minuten Timer',
  'popular.10minute': '10 Minuten Timer',
  'popular.15minute': '15 Minuten Timer',
  'popular.30minute': '30 Minuten Timer',
  'popular.60minute': '60 Minuten Timer',
  'popular.1hour': '1 Stunde Timer',
  'popular.10hour': '10 Stunden Timer',
  'popular.24hour': '24 Stunden Timer',
  'popular.48hour': '48 Stunden Timer',

  // How to use
  'howto.title': 'So stellen Sie einen Timer ein',
  'howto.titleMinutes': 'So stellen Sie einen {{minutes}}-Minuten-Timer ein',
  'howto.titleSeconds': 'So stellen Sie einen {{seconds}}-Sekunden-Timer ein',
  'howto.titleHour': 'So stellen Sie einen {{hours}}-Stunden-Timer ein',
  'howto.titleHours': 'So stellen Sie einen {{hours}}-Stunden-Timer ein',
  'howto.step1': '⚙️ Zeit einstellen: Klicken Sie auf die Stunden- oder Minutenzahlen, um die Zeit direkt zu bearbeiten. Sie können bis zu 23 Stunden und 59 Minuten für jede Aufgabe einstellen.',
  'howto.step2': '⚡ Schnellanpassung: Verwenden Sie die praktischen Schnellzugabe-Tasten, um sofort 30 Sekunden, 1 Minute, 5 Minuten, 10 Minuten oder 30 Minuten zu Ihrem Timer hinzuzufügen.',
  'howto.step3': '▶️ Starten & Steuern: Klicken Sie auf "Start", um den Countdown zu beginnen. Sie können jederzeit pausieren, um eine Pause zu machen und fortzufahren, wenn Sie bereit sind, oder zurücksetzen, um von vorne zu beginnen.',
  'howto.step4': '🔔 Benachrichtigungen erhalten: Erhalten Sie Desktop-Benachrichtigungen und anpassbare Tonalarme, wenn die Zeit abgelaufen ist. Schalten Sie den Ton in der oberen rechten Ecke ein/aus.',
  'howto.step5': '🖥️ Vollbildmodus: Klicken Sie auf die Vollbild-Taste für ablenkungsfreies Timing - perfekt für Präsentationen, Meditation oder fokussierte Arbeitssitzungen.',
  'howto.step6': '📱 Funktioniert überall: Verwenden Sie es auf jedem Gerät - Desktop, Tablet oder Mobilgerät. Kein Download erforderlich, funktioniert direkt in Ihrem Browser.',

  // User review submission
  'reviewSubmission.title': 'Teilen Sie Ihre Erfahrung',
  'reviewSubmission.subtitle': 'Helfen Sie anderen, diesen Timer zu entdecken, indem Sie Ihre Erfahrung teilen',
  'reviewSubmission.ratingLabel': 'Bewerten Sie Ihre Erfahrung',
  'reviewSubmission.commentLabel': 'Ihre Bewertung (optional)',
  'reviewSubmission.commentPlaceholder': 'Erzählen Sie uns, wie dieser Timer Ihnen bei Produktivität, Kochen, Lernen oder anderen Aktivitäten geholfen hat...',
  'reviewSubmission.nameLabel': 'Ihr Name (optional)',
  'reviewSubmission.namePlaceholder': 'Wie sollen wir Ihren Namen anzeigen?',
  'reviewSubmission.submitButton': 'Bewertung absenden',
  'reviewSubmission.thankYou': 'Vielen Dank für Ihre Bewertung!',
  'reviewSubmission.thankYouMessage': 'Ihr Feedback hilft uns, uns zu verbessern und hilft anderen, unseren Timer zu entdecken.',
  'reviewSubmission.error': 'Bitte wählen Sie eine Bewertung aus, bevor Sie absenden.',

  // User reviews
  'reviews.title': 'Das sagen unsere Nutzer',
  'reviews.newReview': 'Neue Bewertung',
  'reviews.mikeZhang': 'Absoluter Wendepunkt für meine Produktivität! Die Pomodoro-Technik mit diesem Timer hat mir geholfen, meine Abschlussarbeit fertigzustellen. Klare Oberfläche, keine Ablenkungen.',
  'reviews.lisaLee': 'Perfekt für die Küche! Nie wieder verkochte Eier. Die Tonalarme sind laut genug, aber nicht störend. Auch meine betagte Mutter liebt ihn.',
  'reviews.johnDeveloper': 'Bester Timer für Codepausen aller Zeiten! Voreingestellte Tasten sparen so viel Zeit. Hilft, Augenbelastung zu vermeiden und hält mich während der Sprints fokussiert.',
  'reviews.msChen': 'Hat mein Klassenmanagement transformiert! Die Schüler genießen zeitgesteuerte Aktivitäten jetzt wirklich. Der visuelle Countdown hält alle bei der Sache.',
  'reviews.fitnessPro': 'Revolutionär für HIIT-Workouts! Genaues Timing, einfache Bedienung auch mit verschwitzten Händen. Meine Kunden lieben den Vollbildmodus.',
  'reviews.sarahMarketer': 'Hat die Effizienz meiner Meetings um 40% gesteigert! Keine endlosen Diskussionen mehr. Zeitlimits erzwingen Entscheidungen und halten alle fokussiert.',
  'reviews.tomChef': 'Unverzichtbar in meiner Restaurantküche! Pasta, Steaks, Saucen - jedes Mal perfektes Timing. Die vielen Schnellzugabe-Tasten sind genial.',
  'reviews.amyStudent': 'Absoluter Wendepunkt beim Lernen! Durchbricht den Prokrastinations-Zyklus mit bewältigbaren Zeitabschnitten. Von Note 4 zu Note 1 dank dieser Methode.',
  'reviews.davidWriter': 'Hat meine Schreibblockade geheilt! 15-Minuten-Schreibsprints erzeugen Schwung. Diesen Monat 3 Artikel veröffentlicht dank diesem Timer.',
  'reviews.rachelTherapist': 'Perfekt für Meditationssitzungen mit Klienten. Die sanften Alarme stören die friedliche Atmosphäre nicht. Sehr professionell.',
  // Preset timer specific reviews
  'reviews.managerZhang': 'Unverzichtbar für die Büroarbeit! Perfekt zum Teeziehen und für Meetingpausen, die klare Oberfläche lenkt nicht von der Arbeit ab.',
  'reviews.mrsLi': 'Perfekter Eieruhr! Weich gekochte Eier nach 3 Minuten werden jedes Mal perfekt, die Tonalarme sind sehr durchdacht, keine verkochten Eier mehr.',
  'reviews.programmerWang': 'Unverzichtbar für Augenübungen während Codepausen, 3 Minuten sind genau richtig zum Entspannen der Augenmuskeln, großartig für den Augenschutz!',

  // Use cases
  'useCases.title': 'Anwendungsfälle für {{minutes}}-Minuten-Timer',
  'useCases.titleSeconds': 'Anwendungsfälle für {{seconds}}-Sekunden-Timer',
  'useCases.titleHours': 'Anwendungsfälle für {{hours}}-Stunden-Timer',

  // Page titles
  'pageTitle': '{{minutes}}-Minuten-Timer',
  'pageTitleSeconds': '{{seconds}}-Sekunden-Timer',
  'pageTitleHour': '{{hours}}-Stunden-Timer',
  'pageTitleHours': '{{hours}}-Stunden-Timer',

  // User names
  'user.mikeZhang': 'Mike Zhang',
  'user.lisaLee': 'Lisa Lee',
  'user.johnDeveloper': 'John Entwickler',
  'user.msChen': 'Frau Chen',
  'user.fitnessPro': 'Fitness-Profi',
  'user.sarahMarketer': 'Sarah Marketing',
  'user.tomChef': 'Chefkoch Tom',
  'user.amyStudent': 'Amy Studentin',
  'user.davidWriter': 'David Autor',
  'user.rachelTherapist': 'Rachel Therapeutin',
  // Preset timer specific users
  'user.managerZhang': 'Manager Zhang',
  'user.mrsLi': 'Frau Li',
  'user.programmerWang': 'Programmierer Wang',

  // Use cases
  'useCases.quickBreak.title': 'Kurze Pause',
  'useCases.quickBreak.desc': 'Kurze Pause zwischen Arbeitssitzungen, um Ihren Geist aufzufrischen und Burnout vorzubeugen',
  'useCases.eyeCare.title': 'Augenpflege-Erinnerung',
  'useCases.eyeCare.desc': 'Befolgen Sie die 20-20-20-Regel: Schauen Sie alle 20 Minuten 20 Sekunden lang auf etwas in 6 Metern Entfernung',
  'useCases.teaBrewing.title': 'Tee ziehen lassen',
  'useCases.teaBrewing.desc': 'Perfekte Ziehzeit für grünen Tee (3 Min.), schwarzen Tee (5 Min.) oder Kräutermischungen',
  'useCases.lightExercise.title': 'Leichte Übungen',
  'useCases.lightExercise.desc': 'Büro-Dehnübungen, Schreibtisch-Yoga oder einfache Übungen gegen sitzende Lebensweise',
  'useCases.meditation.title': 'Achtsamkeit & Meditation',
  'useCases.meditation.desc': 'Geführte Atemübungen, Achtsamkeitspraxis oder Stressabbau-Meditation',
  'useCases.softBoiledEggs.title': 'Koch-Timer',
  'useCases.softBoiledEggs.desc': 'Perfektes Timing für weich gekochte Eier (5 Min.), Pasta kochen oder jede Küchenaufgabe',
  'useCases.quickReading.title': 'Fokussiertes Lesen',
  'useCases.quickReading.desc': 'Konzentrierte Lesesitzungen für Bücher, Artikel oder Lernmaterialien',
  'useCases.phoneCall.title': 'Anruf- & Meeting-Timer',
  'useCases.phoneCall.desc': 'Halten Sie Telefonanrufe auf Kurs, begrenzen Sie Meeting-Dauer oder timen Sie Präsentationen',
  'useCases.focusedWork.title': 'Pomodoro-Arbeitssitzungen',
  'useCases.focusedWork.desc': 'Klassische Pomodoro-Technik - 25 Minuten fokussierte Arbeit gefolgt von einer Pause',
  'useCases.exercise.title': 'Workout & Training',
  'useCases.exercise.desc': 'Hochintensive Intervalle, Zirkeltraining oder spezifische Übungsdauer',
  // 15-minute specific
  'useCases.shortMeeting.title': 'Stand-up-Meetings',
  'useCases.shortMeeting.desc': 'Schnelle Team-Updates, tägliche Standups oder kurze gemeinsame Diskussionen',
  'useCases.powerNap.title': 'Power-Nap',
  'useCases.powerNap.desc': 'Optimale Nickerchen-Dauer für Energieschub ohne Benommenheit',
  'useCases.learning.title': 'Lernsitzungen',
  'useCases.learning.desc': 'Sprachpraxis, Fähigkeiten-Tutorials oder Bildungsvideos',
  'useCases.creativity.title': 'Kreative Sprints',
  'useCases.creativity.desc': 'Brainstorming-Sitzungen, Schreibsprints oder künstlerische Praxis',
  // 30-minute specific
  'useCases.deepWork.title': 'Deep-Work-Sitzung',
  'useCases.deepWork.desc': 'Ausgedehnte fokussierte Arbeit mit minimalen Unterbrechungen für komplexe Aufgaben',
  'useCases.workout.title': 'Komplettes Workout',
  'useCases.workout.desc': 'Vollständige Trainingsroutine, Yoga-Sitzung oder strukturiertes Trainingsprogramm',
  'useCases.study.title': 'Lernblock',
  'useCases.study.desc': 'Intensive Lernsitzungen für Prüfungen, Recherchen oder Kompetenzentwicklung',
  'useCases.presentation.title': 'Präsentationsübung',
  'useCases.presentation.desc': 'Reden proben, Pitches üben oder Präsentationen timen',

  // Timer-specific user reviews
  // 1-minute timer users
  'user.officeWorkerAlex': 'Alex Büro',
  'user.developerSarah': 'Sarah Dev',
  'user.designerMike': 'Mike Design',
  'reviews.officeWorkerAlex': 'Perfekt für schnelle Pausen zwischen Meetings! Nur 1 Minute zum Dehnen und Neufokussieren macht einen riesigen Unterschied.',
  'reviews.developerSarah': 'Großartig für die 20-20-20-Regel - alle 20 Minuten schaue ich 1 Minute lang auf etwas in 6 Metern Entfernung. Meine Augen fühlen sich viel besser an!',
  'reviews.designerMike': 'Ich nutze dies für Mikro-Pausen während intensiver Designarbeit. Kurz aber effektiv zur Burnout-Prävention.',

  // 3-minute timer users
  'user.teaLoverEmily': 'Emily Tee',
  'user.yogatrainerJohn': 'John Yoga',
  'user.busyMomLisa': 'Lisa Mama',
  'reviews.teaLoverEmily': 'Perfektes Timing für meinen grünen Tee! 3 Minuten geben den perfekten Geschmack ohne Bitterkeit. Liebe den Tonalarm!',
  'reviews.yogatrainerJohn': 'Ich nutze dies für schnelle Atemübungen mit Klienten. 3 Minuten sind genau richtig für eine beruhigende Sitzung.',
  'reviews.busyMomLisa': 'Super zum Timen des Zähneputzens meiner Kinder. Sie genießen den Countdown jetzt wirklich!',

  // 5-minute timer users
  'user.meditatorZen': 'Zen-Meister',
  'user.chefTony': 'Chefkoch Tony',
  'user.runnerMia': 'Mia Läuferin',
  'reviews.meditatorZen': 'Perfekt für Anfänger-Meditation. 5 Minuten sind bewältigbar und dennoch effektiv für Achtsamkeitspraxis.',
  'reviews.chefTony': 'Unverzichtbar in meiner Küche! Perfektes Timing für weich gekochte Eier jedes Mal. Professionell und zuverlässig.',
  'reviews.runnerMia': 'Ich nutze dies für Dehnübungen nach dem Laufen. 5 Minuten stellen sicher, dass ich meine Erholungsroutine nicht überspringe!',

  // 10-minute timer users
  'user.studentDavid': 'David Student',
  'user.managerRachel': 'Rachel Managerin',
  'user.writerJames': 'James Autor',
  'reviews.studentDavid': 'Großartig für Lernpausen! 10 Minuten sind perfekt für einen mentalen Reset ohne Momentum zu verlieren.',
  'reviews.managerRachel': 'Ich nutze dies für fokussierte Lesesitzungen. 10 Minuten ununterbrochenes Lesen summiert sich wirklich!',
  'reviews.writerJames': 'Perfekt für zeitgesteuerte Schreibsprints. Der Druck von 10 Minuten hilft mir, Schreibblockaden zu überwinden.',

  // 15-minute timer users
  'user.consultantAmy': 'Amy Beraterin',
  'user.teacherBen': 'Ben Lehrer',
  'user.freelancerSophie': 'Sophie Freiberuflerin',
  'reviews.consultantAmy': 'Ideal für schnelle Kundengespräche und Stand-up-Meetings. Hält Diskussionen fokussiert und produktiv.',
  'reviews.teacherBen': 'Ich nutze dies für Klassenaktivitäten und Gruppenarbeit. Die Schüler bleiben mit dem Zeitlimit engagiert.',
  'reviews.freelancerSophie': 'Perfekte Pomodoro-Sitzungen! 15 Minuten fokussierte Arbeit gefolgt von einer Pause hält mich den ganzen Tag produktiv.',

  // 30-minute timer users
  'user.executiveRobert': 'Robert Executive',
  'user.fitnessCoachMaya': 'Maya Fitness-Coach',
  'user.artistOlivia': 'Olivia Künstlerin',
  'reviews.executiveRobert': 'Ausgezeichnet für Deep-Work-Sitzungen. 30 Minuten ermöglichen bedeutungsvollen Fortschritt ohne überwältigendes Commitment.',
  'reviews.fitnessCoachMaya': 'Perfekt für komplette Workout-Zirkel. Meine Klienten lieben das strukturierte Timing für verschiedene Übungen.',
  'reviews.artistOlivia': 'Großartig für kreative Sitzungen. 30 Minuten geben genug Zeit, um in den Flow-Zustand zu kommen und etwas Bedeutungsvolles zu schaffen.',
};
